document.addEventListener('quick-view:open', async() => {  
  if (BSS_B2B) {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
          ...res
        });
      }
    }
}})

document.addEventListener('cart-drawer:open', async() => {  
  if (BSS_B2B) {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
        BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
          ...res
        });
      }
    }
}})